var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import compositeFlowConfig from 'integration/renewal/config/CompositeFlowConfig';
import Renewal from 'gw-portals-renewal-js/models/Renewal';
import TransactionEntryCtrl from 'gw-portals-policytransaction-common-angular/transactionEntry/TransactionEntryCtrl';

var RenewalEntryCtrl = function (_TransactionEntryCtrl) {
    _inherits(RenewalEntryCtrl, _TransactionEntryCtrl);

    _createClass(RenewalEntryCtrl, null, [{
        key: '$inject',
        get: function get() {
            return ['$scope', '$stateParams', 'transaction.RenewalService', 'RenewalService', '$q', 'ViewModelService', 'StateUtils', 'AvailabilityService', 'WizardFlowService', 'TranslateService', 'UserInfoService', 'paymentType'];
        }
    }]);

    function RenewalEntryCtrl($scope, $stateParams, RenewalService, RenewalJobService, $q, ViewModelService, StateUtils, AvailabilityService, wizardFlowService, TranslateService, UserInfoService, paymentType) {
        _classCallCheck(this, RenewalEntryCtrl);

        var _this = _possibleConstructorReturn(this, (RenewalEntryCtrl.__proto__ || Object.getPrototypeOf(RenewalEntryCtrl)).call(this, $scope, wizardFlowService, StateUtils));

        _this.$stateParams = $stateParams;
        _this.$q = $q;
        _this.RenewalService = RenewalService;
        _this.RenewalJobService = RenewalJobService;
        _this.AvailabilityService = AvailabilityService;
        _this.TranslateService = TranslateService;
        _this.ViewModelService = ViewModelService;
        _this.UserInfoService = UserInfoService;
        _this.paymentType = paymentType;
        _this.wizardFlowService = wizardFlowService;

        _this.startWizardFlow();
        return _this;
    }

    _createClass(RenewalEntryCtrl, [{
        key: 'getCompositeFlow',
        value: function getCompositeFlow() {
            return compositeFlowConfig(this.$q, this.RenewalService, this.RenewalJobService, this.AvailabilityService, this.TranslateService, this.ViewModelService, this.UserInfoService, this.paymentType);
        }
    }, {
        key: 'buildModel',
        value: function buildModel() {
            var _this2 = this;

            return this.RenewalService.loadRenewal(this.$stateParams.selectedRenewal).then(function (modelDTO) {
                var model = _this2.ViewModelService.create(new Renewal(modelDTO), 'pc', 'edge.capabilities.renewal.dto.RenewalDataDTO');
                var resume = _this2.$stateParams.resume;
                return { model: model, resume: resume };
            });
        }
    }], [{
        key: 'returnToDetailsPage',
        value: function returnToDetailsPage(jobID) {
            return ['renewal.detail.summary', { renewalNumber: jobID }];
        }
    }]);

    return RenewalEntryCtrl;
}(TransactionEntryCtrl);

export default RenewalEntryCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-renewal-angular/entry/RenewalEntryCtrl.js
// module id = 1872
// module chunks = 0